import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiderDetail2',
  props: {
  title: { type: String, required: true },
  width: String,
  defaultTab: String,
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



const drawer = ref(false);
const direction = ref("rtl");
const show = () => {
  // console.log("has: ", DrawerComponent.hasInstace(props.elId));
  drawer.value = true;
};



const hide = async () => {
  emits("close");
  await nextTick();
  drawer.value = false;
};
__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
    title: __props.title,
    size: __props.width,
    width: __props.width,
    "append-to-body": true,
    direction: direction.value,
    "before-close": hide,
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "title", "size", "width", "direction"]))
}
}

})